import {
  Component, ElementRef, Input, OnInit, ViewChild, Output, EventEmitter, AfterViewInit,
  ChangeDetectorRef, ChangeDetectionStrategy, NgZone
} from '@angular/core';
import {Router} from '@angular/router';
import {InfluencerPost} from '../../../../../models/influencer';
import {InfluencerService} from '../../../../services/influencer/influencer.service';
import {UserService} from '../../../../services/user.service';
import {NumberUtils} from '../../../../utils/number.utils';
import {platformIconPath} from '../../../../app.constants';

@Component({
  selector: 'influencer-overview-post-content',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './influencer-overview-post-content.component.html',
  styleUrls: ['./influencer-overview-post-content.component.scss']
})
export class InfluencerOverviewPostContentComponent implements OnInit {
  @ViewChild('postContentInner') public postContentInner: ElementRef;
  @ViewChild('postImage') postImage: ElementRef;
  @ViewChild('postImageContainer') postImageContainer: ElementRef;

  @Input()
  public item: InfluencerPost;
  @Input()
  public postId: string;
  @Input()
  public influencerGroupId: number;
  @Input()
  public previewMode: boolean;
  @Input()
  public target: string;
  @Input()
  public displayMode = 'desktop';
  @Output()
  public selectedPost: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public closePopupCardHover: EventEmitter<any> = new EventEmitter<any>();
  public currentInfluencer;

  constructor(private router: Router,
              private influencerService: InfluencerService,
              private _ngZone: NgZone,
              private userService: UserService) {
  }

  ngOnInit() {
    this.currentInfluencer = this.userService.getInfluencerInfo();
  }

  roundNumber(numb: number) {
    return Math.round(numb);
  }

  getPlatformIcon(id: number) {
    return this.influencerService.getPlatformIconById(id);
  }

  addToPreviewed(item) {
    this.selectedPost.emit(item);
  }

  getTitle(fullTitle) {
    if (!fullTitle) {
      return '';
    }
    return fullTitle.slice(0, 199);
  }

  getMediaLink(post: InfluencerPost) {
    if (post.isVideo) {
      return post.isStory ? post.url : post.videoUrl;
    } else {
      return post.imageUrl;
    }
  }

  getPostDetailLink(post: InfluencerPost) {
    return this.currentInfluencer ? `/dashboard/post/${post.urlHash}` : '/post/';
  }

  getPostParams(post: InfluencerPost) {
    return this.currentInfluencer ? {} : {
      influencerId: post.blog_id,
      urlHash: post.urlHash,
      fullUrl: post.url,
      relativePath: post.relativepath,
      influencerGroupId: this.influencerGroupId,
      activeAccount: this.activeAccount,
      hideBackButton: true
    };
  }

  openPostPage(post) {
    if (!post && post.completed) {
      return;
    }
    const currentInfluencer = this.userService.getInfluencerInfo();
    // new influencer platform version
    if (currentInfluencer) {
      return this.router.navigate(['dashboard', 'post', this.item.urlHash]);
    } else {
      return this.router.navigate(['post'], {queryParams: {
        influencerId: this.item.blog_id,
        urlHash: this.item.urlHash,
        fullUrl: this.item.url,
        relativePath: this.item.relativepath,
        activeAccount: this.activeAccount,
        hideBackButton: true
      }});
    }
  }

  get activeAccount() {
    return this.userService.getCompanyId();
  }

  get reach() {
    if (this.item.isStory && !this.item.completed) {
      return '-';
    }
    return NumberUtils.normalizeNumberToString(this.item.reach);
  }

  get impact() {
    if (this.item.isStory && !this.item.completed) {
      return '- %';
    }
    return Math.round(this.item.impact).toFixed(0) + '%';
  }

  gotoPost(e) {
    return this.router.navigate([`dashboard/post/${this.item.urlHash}`]);
  }
  onClose() {
    this.closePopupCardHover.emit();
  }

  onLoadedImage() {
    const postImageContainer = this.postImage.nativeElement.parentElement;
    postImageContainer.classList.add('is-loaded');
  }

  onImageError() {
    this.postImage.nativeElement.src = 'assets/images/No_Image.png';
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/influencer-overview-post-content/influencer-overview-post-content.component.ts